/* Carry only a recognized device model into the matching Care guide. */
(() => {
  const models = new Set(['MY135', 'MY139', 'MY-131B', 'YS35', 'CN69']);
  const contextPaths = new Set([
    '/articles/cleaning', '/articles/no-mist', '/articles/find-instructions',
    '/articles/medicine-compatibility', '/articles/replacement-parts',
    '/articles/warranty', '/troubleshoot', '/contact', '/buy-again'
  ]);
  const normalize = value => {
    const input = String(value || '').trim().toUpperCase();
    const model = input === 'MY131B' ? 'MY-131B' : input;
    return models.has(model) ? model : '';
  };
  function initialize(root = document) {
    const requested = normalize(new URL(window.location.href).searchParams.get('model'));
    root.querySelectorAll('[data-care-link][data-care-path]').forEach(link => {
      const path = link.getAttribute('data-care-path');
      if (!contextPaths.has(path)) return;
      const model = normalize(link.closest('[data-care-bridge]')?.getAttribute('data-care-model')) || requested;
      const url = new URL(path, 'https://mayluck.care');
      if (model) url.searchParams.set('model', model);
      link.href = url.href;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
